import React, { useState } from 'react';
import { useGlobalEvent } from 'beautiful-react-hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import cx from 'classnames';

import { Modal, ModalProps } from '@vimily/bonjoro-ui-components-v2/Modal';

interface CustomDomainProps {
  uid: string;
  children: React.ReactNode;
  showCloseButton?: boolean;
  className?: string;
}

const CustomDomainModal = ({
  uid,
  children,
  showCloseButton = false,
  className,
}: CustomDomainProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const onRequestOpen = useGlobalEvent(`${uid}::open` as keyof WindowEventMap);
  const onRequestClose = useGlobalEvent(
    `${uid}::close` as keyof WindowEventMap
  );

  const handleCloseModal = () => setOpen(false);

  onRequestOpen(() => setOpen(true));
  onRequestClose(handleCloseModal);

  const modalProps: ModalProps = {
    open,
    onModalClose: handleCloseModal,
    hideActions: true,
    hideCloseButton: true,
    className: cx(className, 'w-[649px] !inset-px !p-7'),
  };

  return (
    <Modal {...modalProps}>
      <div className='flex relative'>
        {showCloseButton && (
          <FontAwesomeIcon
            className='ml-auto text-neutral-900 text-xl cursor-pointer absolute top-0 right-0'
            icon={faTimes}
            onClick={handleCloseModal}
          />
        )}
        {children}
      </div>
    </Modal>
  );
};

export default CustomDomainModal;
